import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const PCGamer: Site = {
  id: 'pcgamer',
  logo: 'svg/pcgamer.svg',
  label: 'PC Gamer',
  analyticsName: 'pcg',
  hostname: 'pcgamer.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
